import React__default, { useState, useEffect, useRef } from 'react';
import { Box, LinearProgress, Skeleton, TextField, Pagination } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { pdfjs, Document, Page } from 'react-pdf';
import DefaultIcon from '../../DefaultIcon/index.js';
import KButton from '../../KButtons/index.js';
import StyledPDFViewer, { classes } from './index.styled.js';

pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.min.js");
var PDFViewer = function (_a) {
    var id = _a.id, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "PDFViewer" : _b, file = _a.file, _c = _a.onLoadError, onLoadError = _c === void 0 ? function () { } : _c, _d = _a.onLoadProgress, onLoadProgress = _d === void 0 ? function () { } : _d, _e = _a.onFullScreen, onFullScreen = _e === void 0 ? function () { } : _e, preview = _a.preview, sx = _a.sx, _f = _a.KIcon, KIcon = _f === void 0 ? DefaultIcon : _f;
    var t = useTranslation("refront-components").t;
    var _g = useState(null), numPages = _g[0], setNumPages = _g[1];
    var _h = useState(1), pageNumber = _h[0], setPageNumber = _h[1];
    var _j = useState(0), loadingRatio = _j[0], setLoadingRatio = _j[1];
    var _k = useState(1), jumpPage = _k[0], setJumpPage = _k[1];
    var _l = useState(false), fullscreen = _l[0], setFullscreen = _l[1];
    function onDocumentLoadSuccess(_a) {
        var numPages = _a.numPages;
        setNumPages(numPages);
    }
    var handleLoadProgress = function (data) {
        setLoadingRatio(data.total / data.loaded);
        onLoadProgress(data);
    };
    var loading = function () {
        return (React__default.createElement(Box, { className: clsx("PDFViewer-loading", classes.loading) },
            React__default.createElement(LinearProgress, { value: loadingRatio, className: clsx("PDFViewer-loading-progress", classes.progress) }),
            preview && (React__default.createElement("img", { onContextMenu: function (e) { return e.preventDefault(); }, src: preview.url, className: clsx("PDFViewer-loading-preview", classes.previewImg), alt: preview.alt })),
            !preview && (React__default.createElement(Skeleton, { className: clsx("PDFViewer-loading-preview", classes.previewSkeleton) }))));
    };
    useEffect(function () {
        var jumpTo = jumpPage;
        if (jumpTo > (numPages || 1)) {
            jumpTo = numPages || 1;
        }
        else if (jumpTo <= 0) {
            jumpTo = 1;
        }
        setPageNumber(jumpTo);
    }, [jumpPage, numPages]);
    useEffect(function () {
        setJumpPage(pageNumber);
    }, [pageNumber]);
    var _m = useState(0), viewerWidth = _m[0], setViewerWidth = _m[1];
    var rootRef = useRef(null);
    useEffect(function () {
        var resize = function () {
            var _a, _b;
            var width = (_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
            setViewerWidth(width);
        };
        resize();
        window.addEventListener("resize", resize);
        return function () {
            window.removeEventListener("resize", resize);
        };
    }, [fullscreen, file, preview]);
    useEffect(function () {
        setPageNumber(1);
    }, [file]);
    useEffect(function () {
        onFullScreen(fullscreen);
    }, [fullscreen, onFullScreen]);
    var TypedDocument = Document;
    var TypedPage = Page;
    return (React__default.createElement(StyledPDFViewer, { id: id, className: clsx("PDFViewer", className), "data-testid": testId, ref: rootRef, sx: sx, fullscreen: fullscreen },
        React__default.createElement(TypedDocument, { file: file, onLoadSuccess: onDocumentLoadSuccess, onLoadError: onLoadError, onLoadProgress: handleLoadProgress, loading: loading(), className: clsx("PDFViewer-Document", classes.document), externalLinkTarget: "_blank", "data-testid": "PDFViewer-Document" },
            React__default.createElement(Box, { className: clsx("PDFViewer-toolbar", classes.toolbar) },
                React__default.createElement(Box, null, numPages && numPages > 1 && (React__default.createElement(TextField, { label: t("components.viewer.pdfviewer.pagination.goTo.label"), type: "number", size: "small", value: jumpPage, onChange: function (e) { return setJumpPage(Number(e.target.value)); }, variant: "standard" }))),
                React__default.createElement(Box, null, numPages && numPages > 1 && (React__default.createElement(Pagination, { className: clsx("PDFViewer-Pagination", classes.pagination), size: "small", count: numPages, onChange: function (_, page) { return setPageNumber(page); }, page: pageNumber, showFirstButton: true, showLastButton: true }))),
                React__default.createElement(Box, { className: classes.toolbarRight },
                    !fullscreen && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(KButton, { title: t("components.viewer.pdfviewer.fullscreen.label"), variant: "contained", onClick: function () { return setFullscreen(true); } },
                            React__default.createElement(KIcon, { className: "fa-solid fa-expand" })),
                        React__default.createElement(KButton, { title: t("components.viewer.pdfviewer.openInNew.label"), variant: "contained", onClick: function () { return window.open(file, "_blank"); } },
                            React__default.createElement(KIcon, { className: "fa-regular fa-arrow-up-right-from-square" })))),
                    fullscreen && (React__default.createElement(KButton, { title: t("components.viewer.pdfviewer.closeFullscreen.label"), variant: "text", onClick: function () { return setFullscreen(false); } },
                        React__default.createElement(KIcon, { className: "fa-solid fa-down-left-and-up-right-to-center" }))))),
            React__default.createElement(TypedPage, { width: viewerWidth, className: clsx("PDFViewer-Page", classes.page), pageNumber: pageNumber }))));
};

export { PDFViewer as default };
//# sourceMappingURL=index.js.map
